import { render, staticRenderFns } from "./rwDescriptionOrder.vue?vue&type=template&id=61159ef0&scoped=true"
import script from "./rwDescriptionOrder.vue?vue&type=script&lang=js"
export * from "./rwDescriptionOrder.vue?vue&type=script&lang=js"
import style0 from "./rwDescriptionOrder.vue?vue&type=style&index=0&id=61159ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61159ef0",
  null
  
)

export default component.exports